import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueGoogleMaps from "@fawmi/vue-google-maps";


createApp(App).use(store).use(router).use(i18n).use(VueGoogleMaps, {
    load: {
        key: "AIzaSyCmx9SqNH4PvdVROQ_10DTv_8qkYlaAtUo",
        libraries: "places",
    }
}).mount('#app')
